/**
 * Filename of the build-manifest.json artifact written by
 * config/esbuild/config.js's writeBuildManifest() and read at runtime by
 * platform/utilities/stale-build-detector to detect a stale deploy (see that
 * module for the full explanation).
 *
 * This filename is spelled out in three places that must agree: the two
 * importers of this constant below, plus the CD deploy's exclude filter in
 * script/github-actions/deploy.sh — a bash script, which can't import a JS
 * constant, so it carries a "keep in sync" comment pointing back here instead.
 * @module site/constants/build-manifest
 */

module.exports = {
  BUILD_MANIFEST_FILENAME: 'build-manifest.json',
};
